import type { FC } from 'react'
import { Fragment } from 'react'

import {
  getModalComponent,
  selectors,
} from '@liveHelper/models/modal/modalRegistry'
import { useStore } from '@liveHelper/models/store'

import { ModalContainerPortal } from '@core/modal/modalContainer'

/**
 * A component that renders the currently opened modals in a OneToOne application.
 */
export const OneToOneModalRenderer: FC = () => {
  const openedModals = useStore(selectors.openedModalsSelector)
  const { hideModal } = useStore(selectors.modalActionsSelector)

  return (
    <>
      {openedModals.map((modal) => {
        const Component = getModalComponent(modal.type)
        if (Component) {
          return (
            <Fragment key={modal.id}>
              <ModalContainerPortal>
                <Component
                  {...modal.config}
                  onDismiss={() => hideModal(modal.id)}
                />
              </ModalContainerPortal>
            </Fragment>
          )
        }
      })}
    </>
  )
}
